export enum ApiEC {
    LoginFailed = "login-failed",
    UserInfoFailed = "user-info-failed",
    UserGetFailed = "user-get-failed",
    Logout = "logout",
}
